/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import * as sharedDataAction from './shared-data.actions';
import { SharedDataState } from './shared-data.state';
import { withLoading, withData, withError } from 'app/shared/store/utils/loadable-state';

export function reducer(state: SharedDataState, action: sharedDataAction.All): SharedDataState {
  switch (action.type) {
    // -------------------------------------------------------------------------
    case sharedDataAction.TENANT_ADDED:
      return {
        ...state,
        tenants: {
          data: state.tenants.data
            ? [...state.tenants.data, action.tenantDetails]
            : [action.tenantDetails],
          error: undefined,
          loading: false
        }
      };

    // -------------------------------------------------------------------------
    case sharedDataAction.LOAD_ALL_TENANT_DETAILS:
      return withLoading(state, 'tenants');

    case sharedDataAction.LOAD_ALL_TENANT_DETAILS_SUCCESS:
      return withData(state, 'tenants', action.tenantDetails);

    case sharedDataAction.LOAD_ALL_TENANT_DETAILS_ERROR:
      return withError(state, 'tenants', action.errorMessage);

    // -------------------------------------------------------------------------
    case sharedDataAction.LOAD_PREVIEW_ENVIRONMENTS:
      return withLoading(state, 'previewEnvironments');

    case sharedDataAction.LOAD_PREVIEW_ENVIRONMENTS_SUCCESS:
      return withData(state, 'previewEnvironments', action.previewEnvironments);

    case sharedDataAction.LOAD_PREVIEW_ENVIRONMENTS_ERROR:
      return withError(state, 'previewEnvironments', action.errorMessage);
  }

  return state;
}
